import React, { useContext } from 'react';
import Navbar from './Navbar';
import Banner from './Banner';
import Footer from './Footer';
import Menu from './Menu';
import ErrorBoundary from './ErrorBoundary';
import '../../styles/site.css';
import Toolbar from './Switch';
import { Grid } from '@mui/material';
import Context from './SessionProvider';

const Master = (props) => {
    const { hide, mostrar, ocultar } = useContext(Context);

    const handleChange = (event) => {
        if (event === true) ocultar();
        else mostrar();
    };

    return (
        <>
            
            <Navbar session={props.session} ></Navbar>
            
            {
                props.banner && <Banner start={true} /> 
            }
            {props.session === undefined ? (
                <div className="principal-width" >
                    <div className="flex-container">
                        <div className="sinmenu-width">
                            {props.children}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="principal-width">
                    <div className='col-md-12'>
                        <Toolbar handleChange={handleChange} auth={hide} />
                    </div>

                    <div className="flex-container">
                        <div className="sinmenu-width" style={{ backgroundColor: '#fff' }}>
                            <Grid container>
                                <Grid item xs={12} sm={2} style={{ margin: 0 }}>
                                    {hide ? <Menu hide></Menu> : (<></>)}
                                </Grid>
                                <Grid item xs={hide === false ? 12 : 10} sm={hide === false ? 12 : 10} style={{ margin: 0, padding: 0, marginTop: 60 }}>
                                    <ErrorBoundary>{props.children}</ErrorBoundary>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
            )}

            
            <Footer logged={props.footer} />
            
        </>
    )
}
/* retorna true si al pasar los nextProps a renderizar retorna el mismo resultado que al pasar los prevProps a renderizar, de otro modo retorna false */
function validaProps(prevProps, nextProps) {
    // console.log(equalarray(prevProps.poliza, nextProps, (prevProps.value === nextProps.value), (JSON.stringify(prevProps.poliza[0]) === JSON.stringify(nextProps.poliza[0]))); 
    //si retorna un falso renderiza todo el componente, porque si es falso significa que el valor cambio
    //falso es igual que son diferentes
    //si son muchos objetos va si [0]
    return (prevProps.session === nextProps.session && prevProps.hide === nextProps.hide);
}

export default React.memo(Master, validaProps);